import { createApp } from 'vue'
import { useApiClient, usePartnerClient } from '@freebe/sdk/store'
import { useComponents } from './components'
import { usePlugins } from './plugins'
import App from '@layouts/app'
import router from './router'
import store from './store'

useApiClient(`//${process.env.APP_API_URL}`)

const app = createApp(App)
  .use(router)
  .use(store)

useComponents(app)
usePlugins(app)

export default app
  
